import React from "react";
import { Col } from "reactstrap";

// Theme style
import "./lightTheme.scss";

//Redux
import { useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const UsernameConversation = ({ t }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  importDarkMode(mainTheme);
  
  return (
    <Col xs="12 clientInfoTitle">
      <h5 className="font-size-15 mt-2 text-wrap pl-0 d-flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 40 40"
          style={{position: 'relative', top: '-9px'}}
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#bfc8e2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.2"
          >
            <path d="m2.513 12.833 9.022 5.04a.995.995 0 0 0 .973.001l8.978-5a1 1 0 0 0-.002-1.749l-9.022-5a1 1 0 0 0-.968-.001l-8.978 4.96a1 1 0 0 0-.003 1.749z" transform="translate(8 8)"></path>
            <path d="m3.485 15.126-.971 1.748 9 5a1 1 0 0 0 .971 0l9-5-.971-1.748L12 19.856l-8.515-4.73zM20 8V6h2V4h-2V2h-2v2h-2v2h2v2z" transform="translate(8 8)"></path>
          </g>
        </svg>
        {t("Aditional Fields")}
      </h5>      
    </Col>
  );
};

export default withTranslation()(UsernameConversation);
